import React, { FC, useRef } from "react";
import { fileSizeFormat, useDialogShadow } from "@evergis/ui";
import { useTranslation } from "react-i18next";
import { useCheckLimits } from "../../../../hooks/useCheckLimits";

import { DialogActions } from "../../DialogComponents/DialogActions";
import { DialogTitle } from "../../DialogComponents/DialogTitle";
import { FileUploader } from "../../DialogComponents/FileUploader/FileUploader";
import { FullScreenDialog } from "../../DialogComponents/FullScreenDialog";
import { DialogContent, RestrictedWidthContainer } from "../../DialogComponents/styled";
import { UploadDescription } from "../styled";
import { useUploadDataContext } from "../uploadDataContext";
import { useContext } from "../hooks/useContext";
import { DEFAULT_UPLOAD_MAX_FILE_SIZE } from "../constants";

export const UploadFiles: FC = () => {
  const { t } = useTranslation("dialogs");
  const context = useContext();
  const { shadows, setScrollContainer } = useDialogShadow();
  const { uploadDone, uploadedFiles, uploadFiles, uploadFileURL, uploadDelete, nextText, nextStep } =
    useUploadDataContext();
  const uploaderRef = useRef();
  const { limits } = useCheckLimits();

  const uploadMaxFileSize = limits?.maxUploadContentSize || DEFAULT_UPLOAD_MAX_FILE_SIZE;

  return (
    <FullScreenDialog dialogContext={context}>
      <DialogTitle displayShadow={shadows.upper} />
      <DialogContent ref={setScrollContainer}>
        <RestrictedWidthContainer>
          <UploadDescription>
            {uploadMaxFileSize !== -1 && (
              <div>
                {t("uploadData.maxRasterCount")}
                <strong>{fileSizeFormat(uploadMaxFileSize)}</strong>.
              </div>
            )}
            <div>
              {t("uploadData.supportedFileTypes")} <abbr title="GeoTIFF">GeoTIFF</abbr>
            </div>
          </UploadDescription>
          <FileUploader
            currentRef={uploaderRef}
            fileItems={uploadedFiles}
            width={"calc(100% - 4rem)"}
            minHeight={"7rem"}
            isMultiple
            onUpload={uploadFiles}
            onDelete={uploadDelete}
            onFileUrlUpload={uploadFileURL}
          />
        </RestrictedWidthContainer>
      </DialogContent>
      <DialogActions
        displayShadow={shadows.bottom}
        applyDisabled={!uploadDone || !uploadedFiles.length}
        applyText={nextText}
        onApply={nextStep}
      />
    </FullScreenDialog>
  );
};
